const JUBILEE_START = '2026-08-16T00:00:00'
const JUBILEE_END = '2027-01-01T00:00:00'

/** Formats a Date as YYYY-MM-DDTHH:mm:ss in Europe/Amsterdam. */
const formatAmsterdam = (date: Date): string => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date)

  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? ''

  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get(
    'minute'
  )}:${get('second')}`
}

/**
 * True from 16 Aug 2026 00:00 through 31 Dec 2026 (Europe/Amsterdam).
 * False from 1 Jan 2027 00:00 onwards.
 */
export const isJubileePeriod = (date: Date = new Date()): boolean => {
  const amsterdamNow = formatAmsterdam(date)
  return amsterdamNow >= JUBILEE_START && amsterdamNow < JUBILEE_END
}
